/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMlBinary = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M5.5 15a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7zm0 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm13-2a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7zm0 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-7.643-8.485L9.1 11.445l1.659-.415.484 1.94-4 1a1 1 0 0 1-1.212-.728l-1-4 1.94-.484.414 1.657 1.759-2.93zm5.758 1.9.415-1.657 1.94.484-1 4a1 1 0 0 1-1.212.728l-4-1 .484-1.94 1.658.414-1.757-2.93 1.714-1.029zM12 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgMlBinary as MlBinary };
